<mat-card class="error">
  <mat-card-title> Unauthorized </mat-card-title>
  <mat-card-content>
    {{ auth0ErrorDescriptionTranslations[description] || description || 'Your login has expired.' }}
  </mat-card-content>
</mat-card>

<app-login></app-login>
